module.exports = __webpack_public_path__ + "static/media/liquid@2x.0693da88.png";